import React from 'react';

import { func, object, arrayOf } from 'prop-types';
import { connect } from 'react-redux';
import { Snackbar } from '@mui/material';

import { closeNotification, clearNotifications } from 'actions/uiActions';

import NotificationContent from './components/NotificationContent';

const Notifications = ({
  notifications,
  doCloseNotification,
  doClearNotifications
}) => {
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left'
      }}
      open={notifications.length > 0}
      onClose={doClearNotifications}
      ContentProps={{
        'aria-describedby': 'message-id'
      }}>
      <div>
        {notifications.map((notification, i) => {
          const { variant, message, id } = notification;
          return (
            <NotificationContent
              onClose={doCloseNotification}
              id={id}
              variant={variant}
              message={message}
              key={`${id}-${i}`}
            />
          );
        })}
      </div>
    </Snackbar>
  );
};

const mapStateToProps = state => ({
  notifications: state.ui.notifications,
  loading: state.ui.loading
});

const mapDispatchToProps = dispatch => ({
  doCloseNotification: message => dispatch(closeNotification(message)),
  doClearNotifications: () => dispatch(clearNotifications())
});

Notifications.propTypes = {
  notifications: arrayOf(object),
  doCloseNotification: func.isRequired,
  doClearNotifications: func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
